import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const PF2MNumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, name, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.floatValue,
          },
        });
      }}
      decimalScale={2}
      allowNegative={false}
      decimalSeparator="."
    />
  );
});

PF2MNumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
};

PF2MNumberFormatCustom.defaultProps = {
  name: undefined,
};

export default PF2MNumberFormatCustom;
